<script lang="ts">
    import { getContext } from "svelte";
    import paginate from "jw-paginate";
    import type { Pager, Paginator } from "../types/paginator";

    let pager: Paginator;
    const {
        total,
        page,
        perPage,
        maxPages = 5,
        pageSizeOptions = [
            { id: 10, name: "10" },
            { id: 20, name: "20" },
            { id: 50, name: "50" },
            { id: 100, name: "100" },
        ],
        setPage,
        setPageSize,
    }: Pager = getContext("pager");

    $: pager = paginate(total, page, perPage, maxPages);
</script>

{#if pager.pages && pager.totalItems > 1}
    <div class="bno-pagination__wrap">
        <nav
            class="bno-pagination"
            role="navigation"
            aria-label="Stránkování výsledků"
        >
            {#if pager.pages.length > 1}
                <ol class="bno-pagination__items">
                    {#if pager.currentPage !== 1}
                        <li
                            class="bno-pagination__item"
                            class:disabled={pager.currentPage === 1}
                        >
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a
                                class="bno-pagination__link"
                                aria-label="První strana"
                                on:click|preventDefault={() => setPage(1)}
                            >
                                <span aria-hidden="true">«</span>
                                <span class="u-sr-only">První strana</span>
                            </a>
                        </li>
                        <li
                            class="bno-pagination__item"
                            class:disabled={pager.currentPage === 1}
                        >
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a
                                class="bno-pagination__link"
                                aria-label="Předchozí strana"
                                on:click|preventDefault={() =>
                                    setPage(pager.currentPage - 1)}
                            >
                                <span aria-hidden="true">‹</span>
                                <span class="u-sr-only">Předchozí strana</span>
                            </a>
                        </li>
                    {/if}
                    {#if pager.startPage > 1}
                        <li class="bno-pagination__item" role="presentation">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a
                                class="bno-pagination__link is-ellipsis"
                                aria-label="…">…</a
                            >
                        </li>
                    {/if}
                    {#each pager.pages as page}
                        <li class="bno-pagination__item">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a
                                class="bno-pagination__link"
                                class:is-active={pager.currentPage === page}
                                aria-label="Strana {page}"
                                aria-current={pager.currentPage === page
                                    ? "page"
                                    : undefined}
                                on:click|preventDefault={() => setPage(page)}
                            >
                                <span class="u-sr-only">Strana</span>
                                {page}
                            </a>
                        </li>
                    {/each}
                    {#if pager.endPage < pager.totalPages}
                        <li class="bno-pagination__item" role="presentation">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a
                                class="bno-pagination__link is-ellipsis"
                                aria-label="…">…</a
                            >
                        </li>
                    {/if}
                    {#if pager.totalPages !== pager.currentPage}
                        <li class="bno-pagination__item">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a
                                class="bno-pagination__link"
                                aria-label="Následující strana"
                                on:click|preventDefault={() =>
                                    setPage(pager.currentPage + 1)}
                            >
                                <span aria-hidden="true">›</span>
                                <span class="u-sr-only">Následující strana</span
                                >
                            </a>
                        </li>
                        <li class="bno-pagination__item">
                            <!-- svelte-ignore a11y-missing-attribute -->
                            <a
                                class="bno-pagination__link"
                                aria-label="Poslední strana"
                                on:click|preventDefault={() =>
                                    setPage(pager.totalPages)}
                            >
                                <span aria-hidden="true">»</span>
                                <span class="u-sr-only">Poslední strana</span>
                            </a>
                        </li>
                    {/if}
                </ol>
            {/if}
            <div class="bno-pagination__details">
                <div
                    class="bno-form-control bno-form-control--small bno-pagination__select"
                >
                    <div class="bno-select">
                        <select
                            id="select-0"
                            name="custom-select"
                            aria-required="false"
                            aria-disabled="false"
                            bind:value={pager.pageSize}
                            on:change|preventDefault={() =>
                                setPageSize(pager.pageSize)}
                        >
                            {#each pageSizeOptions as option}
                                <option value={option.id}>{option.name}</option>
                            {/each}
                        </select>
                        <label class="bno-form-control__label" for="select-0">
                            Záznamů na stránku
                        </label>
                    </div>
                </div>
                <span
                    >Zobrazuji <strong
                        >{pager.startIndex + 1}
                        - {pager.endIndex + 1}</strong
                    >
                    z <strong>{pager.totalItems}</strong></span
                >
            </div>
        </nav>
    </div>
{/if}
